import React from 'react';

import { GetShotDateString } from "../../../components/common/Common";
import cancelIcon from "../../../img/icon/icon-cancel.svg";

const SearchChildrens = ({varPopupSearchChildrens,varChildrenList,onSelectChildrenHandler,ToggleSearchChildrens}) => {

  return (
    <div className="layer-pop layer-kids" style={varPopupSearchChildrens?{display:"block"}:{display:"none"}}>
      <div className="layer-hd">
        <div className="tit">원생 선택</div>
        <div className="close-layer" onClick={()=>ToggleSearchChildrens(false)}><img src={cancelIcon} alt=""/></div>
      </div>
      <div className="check-group vertical" style={{height:"400px",overflowY:"scroll"}}>
        {varChildrenList.map((children,i)=>(
          <div className="checkbox2" key={'children_'+i} onClick={e=>onSelectChildrenHandler(e,children)}>
            {/* <input type="radio" name="radioName"/> */}
            <label className="active">
              <div className="value">
                <div className="name">{children.ch_name}</div>
                <div className="date">{GetShotDateString(children.ch_birthday)}</div>
              </div>
            </label>
          </div>
        ))}
      </div>
    </div>
  )
}
export default SearchChildrens;